import { render } from "./createstockadjustment.vue?vue&type=template&id=613a124f&scoped=true"
import script from "./createstockadjustment.vue?vue&type=script&lang=js"
export * from "./createstockadjustment.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createstockadjustment.vue?vue&type=style&index=1&id=613a124f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613a124f"]])

export default __exports__